export const DEFAULT_SCENE = 'shift-templates';
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;

export const ADD_SHIFT_TEMPLATE_BUTTON_TAG = `${DEFAULT_SCENE}:button-add`;

// Sidebar content
export const ADD_NEW_BREAK_BUTTON = `${DEFAULT_SCENE}:break:add-new`;
export const SAVE_SHIFT_TEMPLATE_BUTTON_TAG = `${DEFAULT_SCENE}:button-save`;
export const REMOVE_BREAK_BUTTON = `${DEFAULT_SCENE}:break:remove-button`;
export const RESET_BREAK_SETTINGS_BUTTON = `${DEFAULT_SCENE}:break:reset-button`;
export const SHIFT_END_TIME_INFO = `${DEFAULT_SCENE}:shift-end-time`;
export const SHIFT_BREAK_CONTAINER = `${DEFAULT_SCENE}:shift-break`;
export const SHIFT_BREAKS_CONTAINER = `${DEFAULT_SCENE}:shift-breaks`;
export const SHIFT_SCHEDULE_ACTIVITIES_CONTAINER = `${DEFAULT_SCENE}:schedule-activities`;
export const SHIFT_EVEN_WEEK_SWITCHER = `${DEFAULT_SCENE}:even-week-switcher`;
export const SHIFT_EVEN_ODD_WEEK_DAY_BUTTON = `${DEFAULT_SCENE}:button-even-odd-week-day`;
export const SHIFT_EVEN_ODD_WEEK_CLEAR_BUTTON = `${DEFAULT_SCENE}:button-even-odd-week-clear`;
export const SHIFT_EVEN_ODD_WEEK_DUPLICATE_BUTTON = `${DEFAULT_SCENE}:button-even-odd-week-duplicate`;
export const SHIFT_EVEN_ODD_WEEK_CONFIRM_SELECTION_BUTTON = `${DEFAULT_SCENE}:button-even-odd-week-confirm-selection`;
export const SHIFT_EVEN_ODD_WEEK_CANCEL_SELECTION_BUTTON = `${DEFAULT_SCENE}:button-even-odd-week-cancel-selection`;

// Sidebar bulk - assign content
export const ASSIGN_SHIFT_CONTAINER_TAG = `${DEFAULT_SCENE}:bulk-assign:container`;
export const ASSIGN_SHIFT_HEADING_TAG = `${DEFAULT_SCENE}:bulk-assign:heading`;
export const ASSIGN_SHIFT_FILTER_BOX_TAG = `${DEFAULT_SCENE}:bulk-assign:filter-box`;
export const ASSIGN_SHIFT_BUTTON_TAG = `${DEFAULT_SCENE}:button-assign`;

const LIST = `${DEFAULT_SCENE}:list`;
export const LIST_CONTAINER_TAG = `${LIST}:container`;
export const getListItemTag = (propName: string) => `${LIST}:shift-template-${propName}`;

export const getFieldsInputTag = (fieldName: string) => `${DEFAULT_SCENE}:input-${fieldName}`;

export const LIST_PAGINATION_TAG = `${LIST}:pagination`;
